export default "__VITE_ASSET__BTbMGM1Q__"